module.exports = __webpack_public_path__ + "img/recolumn_example3.b55aa22f.png";